export enum GameDurationEnum {
  Minutes90 = 90,
  Minutes70 = 70,
  Minutes40 = 40,
  Minutes20 = 20,
}
